export default __webpack_public_path__ + "static/media/cc_beige.900ff2f7.jpg";